import { useSelector, useDispatch } from 'react-redux'

import { ModalForm } from 'components/common'
import TenantServiceApi, { pkField, getDetailUrl } from 'models/TenantService/api'
import { TenantServiceActions } from 'models/TenantService/slice'

import MainFieldSet from './MainFieldSet'


const TenantServiceForm = ({ mode = "list", initials }) => {
  const { activeForm, formDetailPK } = useSelector(state => state.tenantService);

  const [apiGetFormDetail, apiGetFormDetailProps] = TenantServiceApi.endpoints.getTenantServiceFormDetail.useLazyQuery();
  const [apiUpdate, apiUpdateProps] = TenantServiceApi.endpoints.updateTenantService.useMutation();

  const dispatch = useDispatch();

  const formDetail = apiGetFormDetailProps.data;

  const onFinish = (values) => {
    apiUpdate(values);
  };

  return (
    <ModalForm
      name="TenantService"
      title={formDetailPK ? `Категория «${formDetail?.name}»`: 'Новая категория'}
      width={700}
      mode={mode}
      visible={activeForm === 'editForm'}

      pkField={pkField}
      formDetailPK={formDetailPK}

      getDetailUrl={getDetailUrl}
      apiGetFormDetail={apiGetFormDetail}
      apiGetFormDetailProps={apiGetFormDetailProps}
      apiUpdateProps={apiUpdateProps}
      api={TenantServiceApi}

      onFinish={onFinish}
      onClose={() => dispatch(TenantServiceActions.closeForm())}
      initialValues={{
        sort: 100,
        ...initials
      }}

      prepareFormValues={(detail) => {
        return {
          ...detail,
        }
      }}
    >
      <MainFieldSet />
    </ModalForm>
  );
}


export default TenantServiceForm
